export default __webpack_public_path__ + "static/media/Asset Banner 3@3x.77595aa5.png";